// LoginModal.js
// 从 App.js 抽取出的「登录/注册」弹窗组件（完整版：登录、注册、找回密码、微信登录 四个标签页）
// 学单词/学用法/学句子页面统一使用同一份，避免出现功能不一致（此前学句子页只有一个简化的登录框）

import React from 'react';
import WxQrCode from './WxQrCode';

function LoginModal({
  showLoginModal,
  setShowLoginModal,
  theme,
  isMobile,
  isHovering,
  loginTab,
  setLoginTab,
  authError,
  setAuthError,
  email,
  setEmail,
  password,
  setPassword,
  emailInputRef,
  passwordInputRef,
  handleLoginFocus,
  handleLogin,
  handleRegister,
  handleResetPassword,
  apiBase,
}) {
  if (!showLoginModal) return null;

  const inputStyle = {
    width: '100%',
    padding: '10px 14px',
    marginBottom: '12px',
    border: `1px solid ${theme === 'dark' ? '#444' : '#ddd'}`,
    borderRadius: '8px',
    fontSize: '1em',
    outline: 'none',
    background: theme === 'dark' ? '#2a2a2a' : '#fafafa',
    color: theme === 'dark' ? '#fff' : '#333',
    boxSizing: 'border-box',
  };

  return (
    <div
      onClick={() => setShowLoginModal(false)}
      style={{
        position: 'fixed',
        inset: 0,
        backgroundColor: 'rgba(0,0,0,0.5)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 9999,
      }}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        style={{
          background: theme === 'dark' ? '#1f1f1f' : 'white',
          borderRadius: '16px',
          padding: '32px',
          width: isMobile ? '90vw' : '400px',
          boxShadow: '0 20px 60px rgba(0,0,0,0.3)',
          position: 'relative',
        }}
      >
        {/* 关闭按钮 */}
        <button
          onClick={() => setShowLoginModal(false)}
          style={{
            position: 'absolute',
            top: '16px',
            right: '16px',
            background: 'none',
            border: 'none',
            fontSize: '1.2em',
            cursor: 'pointer',
            color: theme === 'dark' ? '#aaa' : '#999',
            lineHeight: 1,
          }}
        >
          ✕
        </button>

        {/* Logo + 标题 */}
        <div style={{ textAlign: 'center', marginBottom: '24px' }}>
          <img src="/logo.png" alt="logo" style={{
              height: '2.2em',
              width: 'auto',
              verticalAlign: 'middle',
              animation: isHovering
                ? 'spin 1s ease-in infinite'
                : 'spinDown 2s ease-out forwards',
            }} />
          <h2 style={{ margin: 0, fontSize: '1.4em', color: theme === 'dark' ? '#fff' : '#333' }}>
            削词侠
          </h2>
          <p style={{ margin: '4px 0 0', fontSize: '0.85em', color: '#999' }}>
            削掉已会 只学不会
          </p>
        </div>

        {/* 标签页切换 */}
        <div style={{
          display: 'flex',
          borderBottom: `2px solid ${theme === 'dark' ? '#333' : '#f0f0f0'}`,
          marginBottom: '24px',
          gap: '0',
        }}>
          {[
            { key: 'login', label: '登录' },
            { key: 'register', label: '注册' },
            { key: 'reset', label: '找回密码' },
            { key: 'wechat', label: '微信登录' },
          ].map(tab => (
            <button
              key={tab.key}
              onClick={() => { setLoginTab(tab.key); setAuthError(null); }}
              style={{
                flex: 1,
                padding: '8px 4px',
                background: 'none',
                border: 'none',
                borderBottom: loginTab === tab.key ? '2px solid #1890ff' : '2px solid transparent',
                marginBottom: '-2px',
                color: loginTab === tab.key ? '#1890ff' : (theme === 'dark' ? '#aaa' : '#999'),
                fontWeight: loginTab === tab.key ? '700' : '400',
                cursor: 'pointer',
                fontSize: '0.9em',
                transition: 'all 0.2s',
                whiteSpace: 'nowrap',
              }}
            >
              {tab.label}
            </button>
          ))}
        </div>

        {/* 错误提示 */}
        {authError && (
          <p style={{
            color: authError.includes('已发送') ? '#52c41a' : '#ff4d4f',
            background: authError.includes('已发送') ? '#f6ffed' : '#fff2f0',
            border: `1px solid ${authError.includes('已发送') ? '#b7eb8f' : '#ffccc7'}`,
            borderRadius: '6px',
            padding: '8px 12px',
            fontSize: '0.85em',
            margin: '0 0 16px',
          }}>
            {authError}
          </p>
        )}

        {/* 登录表单 */}
        {loginTab === 'login' && (
          <form onSubmit={handleLogin}>
            <input
              ref={emailInputRef}
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              onFocus={handleLoginFocus}
              placeholder="电子邮件"
              style={inputStyle}
            />
            <input
              ref={passwordInputRef}
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              onFocus={handleLoginFocus}
              placeholder="密码"
              style={{ ...inputStyle, marginBottom: '20px' }}
            />
            <button
              type="submit"
              style={{
                width: '100%',
                padding: '11px',
                background: '#1890ff',
                color: 'white',
                border: 'none',
                borderRadius: '8px',
                fontSize: '1em',
                fontWeight: '600',
                cursor: 'pointer',
              }}
            >
              登录
            </button>
            <p style={{ textAlign: 'center', margin: '12px 0 0', fontSize: '0.85em', color: '#999' }}>
              没有账号？
              <button type="button" onClick={() => setLoginTab('register')}
                style={{ background: 'none', border: 'none', color: '#1890ff', cursor: 'pointer', fontSize: '0.85em' }}>
                立即注册
              </button>
            </p>
          </form>
        )}

        {/* 注册表单 */}
        {loginTab === 'register' && (
          <form onSubmit={handleRegister}>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              onFocus={handleLoginFocus}
              placeholder="电子邮件"
              style={inputStyle}
            />
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              onFocus={handleLoginFocus}
              placeholder="密码（至少6位）"
              style={{ ...inputStyle, marginBottom: '20px' }}
            />
            <button
              type="submit"
              style={{
                width: '100%',
                padding: '11px',
                background: '#52c41a',
                color: 'white',
                border: 'none',
                borderRadius: '8px',
                fontSize: '1em',
                fontWeight: '600',
                cursor: 'pointer',
              }}
            >
              注册
            </button>
            <p style={{ textAlign: 'center', margin: '12px 0 0', fontSize: '0.85em', color: '#999' }}>
              已有账号？
              <button type="button" onClick={() => setLoginTab('login')}
                style={{ background: 'none', border: 'none', color: '#1890ff', cursor: 'pointer', fontSize: '0.85em' }}>
                立即登录
              </button>
            </p>
          </form>
        )}

        {/* 找回密码 */}
        {loginTab === 'reset' && (
          <form onSubmit={handleResetPassword}>
            <p style={{ fontSize: '0.9em', color: '#999', marginBottom: '16px' }}>
              输入注册邮箱，我们将发送重置密码链接
            </p>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              onFocus={handleLoginFocus}
              placeholder="电子邮件"
              style={{ ...inputStyle, marginBottom: '20px' }}
            />
            <button
              type="submit"
              style={{
                width: '100%',
                padding: '11px',
                background: '#1890ff',
                color: 'white',
                border: 'none',
                borderRadius: '8px',
                fontSize: '1em',
                fontWeight: '600',
                cursor: 'pointer',
              }}
            >
              发送重置邮件
            </button>
          </form>
        )}

        {/* 微信登录 */}
        {loginTab === 'wechat' && (
          <WxQrCode apiBase={apiBase} />
        )}
      </div>
    </div>
  );
}

export default LoginModal;
